// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgLogoMessengerMonochrome = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.625 11.96c0-5.226 4.094-9.094 9.375-9.094s9.375 3.868 9.375 9.093c0 5.226-4.094 9.094-9.375 9.094-.949 0-1.859-.125-2.714-.36a.748.748 0 0 0-.5.036l-1.861.822a.75.75 0 0 1-1.053-.663l-.05-1.668a.749.749 0 0 0-.253-.534c-1.824-1.632-2.944-3.994-2.944-6.727Zm6.5-1.708L6.37 14.62c-.264.42.251.892.646.592l2.958-2.245a.562.562 0 0 1 .678-.002l2.19 1.643c.658.493 1.596.32 2.034-.375l2.754-4.37c.264-.419-.252-.891-.646-.592l-2.958 2.245a.562.562 0 0 1-.678.002l-2.19-1.642a1.406 1.406 0 0 0-2.034.375Z"
      fill="#fff"
    />
  </svg>
))
SvgLogoMessengerMonochrome.displayName = 'SvgLogoMessengerMonochrome'
const Memo = memo(SvgLogoMessengerMonochrome)
export { Memo as SvgLogoMessengerMonochrome }
